import { render } from "./MessageTemplateForm.vue?vue&type=template&id=53f0a604&scoped=true"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js"

import "./MessageTemplateForm.vue?vue&type=style&index=0&id=53f0a604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f0a604"]])

export default __exports__